import type { ReactNode } from 'react';

import { Button } from './Button';

interface Props {
  icon?: ReactNode;
  title: string;
  body?: string;
  cta?: {
    label: string;
    onClick: () => void;
  };
}

export function EmptyState({ icon, title, body, cta }: Props) {
  return (
    <div className="mx-auto max-w-[320px] py-10 text-center">
      {icon ? (
        <div className="mx-auto mb-3 inline-flex h-12 w-12 items-center justify-center rounded-full bg-pb-accent-soft text-pb-accent">
          {icon}
        </div>
      ) : null}
      <h3 className="pb-display text-[18px]">{title}</h3>
      {body ? (
        <p className="pb-caption mt-2 whitespace-pre-line">{body}</p>
      ) : null}
      {cta ? (
        <div className="mt-4">
          <Button variant="primary" onClick={cta.onClick}>
            {cta.label}
          </Button>
        </div>
      ) : null}
    </div>
  );
}
